import React, { useState, useContext } from 'react';
import Header from '../Common/Header';
import Sidebar from '../Common/Sidebar';
import Footer from '../Common/Footer';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { GMCContext } from '../../GMCContext';
import axios from 'axios';


export default function News() {
    const { setIsSidebarEnabled } = useContext(GMCContext);

    // States for Manage Deposit
    const [depositStatus, setDepositStatus] = useState('');
    const [depositReason, setDepositReason] = useState('');
    const [depositFormSubmitted, setDepositFormSubmitted] = useState(false);

    // States for Manage Withdrawal
    const [withdrawalStatus, setWithdrawalStatus] = useState('');
    const [withdrawalReason, setWithdrawalReason] = useState('');
    const [withdrawalFormSubmitted, setWithdrawalFormSubmitted] = useState(false);

    // Authantication
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [authNumber, setAuthNumber] = useState('');
    const [msg, setMsg] = useState('');
    const [showMsg, setShowMsg] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [error, setError] = useState(false);


    // Authantication Function 
    const insertCode = async () => {
        try {
            const state = JSON.parse(localStorage.getItem('mark#0143'));
            const response = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
                method: "verify",
                submethod: "insert",
                key: process.env.REACT_APP_KEY,
                authNumber,
                username: state.username,
                _id: state._id,
            });

            const { resCode, error, token } = response.data;

            if (resCode === 200 && token) {
                setMsg("Verified Successfully");
                setShowMsg(true);
                setIsAuthenticated(true);
            } else {
                setErrorMessage(error || "Verification Failed. Please Try Again.");
                setError(true);
            }
        } catch (err) {
            console.error("Error Inserting Data:", err);
            setErrorMessage("Network Error. Please Try Again Later.");
            setError(true);
        }
    };


    // Handlers for Manage Deposit
    const handleDepositStatusChange = (event) => {
        setDepositStatus(event.target.checked ? 'activ' : 'nonActiv');
        setDepositFormSubmitted(false);
    };


    const handleDepositReasonChange = (event) => {
        setDepositReason(event.target.value);
    };


    const handleDepositSubmit = async (event) => {
        event.preventDefault();
        if (withdrawalStatus === 'nonActiv' && !withdrawalReason) {
            toast.error("Please Provide A Valid Reason For Non-Activation In Withdrawal.", { position: 'top-right' });
        } else {
            try {
                const response = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
                    methode: 'admin',
                    submethod: 'updatetstatus',
                    status: depositStatus,
                    msg: depositReason,
                    key: process.env.REACT_APP_KEY,
                });
                // console.log('response.data.error', response)
                if (response.status === 200) {
                    toast.success("Deposit Status Updated Successfully!", { position: 'top-right' });

                } else {
                    toast.error("Failed To Update Deposit Status.", { position: 'top-right' });
                    setDepositFormSubmitted(true);
                }
            } catch (error) {
                console.error(error);
                toast.error("An Error Occurred While Updating Deposit Status.", { position: 'top-right' });
            }
        }
    };


    // Handlers for Manage Withdrawal
    const handleWithdrawalStatusChange = (event) => {
        setWithdrawalStatus(event.target.checked ? 'activ' : 'nonActiv');
        setWithdrawalFormSubmitted(false);
    };


    const handleWithdrawalReasonChange = (event) => {
        setWithdrawalReason(event.target.value);
    };


    const handleWithdrawalSubmit = async (event) => {
        event.preventDefault();
        if (withdrawalStatus === 'nonActiv' && !withdrawalReason) {
            toast.error("Please Provide A Valid Reason For Non-Activation In Withdrawal.", { position: 'top-right' });
        } else {
            try {
                const response = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
                    methode: 'admin',
                    submethod: 'updatew',
                    status: withdrawalStatus,
                    msg: withdrawalReason,
                    key: process.env.REACT_APP_KEY,
                });

                if (response.data.error) {
                    toast.error("Failed To Update Withdrawal Status.", { position: 'top-right' });
                } else {
                    toast.success("Withdrawal Status Updated Successfully!", { position: 'top-right' });
                    setWithdrawalFormSubmitted(true);
                }
            } catch (error) {
                console.error(error);
                toast.error("An Error Occurred While Updating Withdrawal Status.", { position: 'top-right' });
            }
        }
    };

    return (
        <>
            <Header />
            <Sidebar />
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid" onClick={() => setIsSidebarEnabled((prev) => !prev)}>
                        {!isAuthenticated ? (
                            // Authentication Form
                            <div className="col-md-6 mx-auto" style={{ marginTop: "20vh" }}>
                                <div className="card shadow-lg rounded p-4">
                                    <div className="text-center mb-4">
                                        <h4 className="text-primary">Verify Your Authentication Key!</h4>
                                    </div>
                                    <form autoComplete="off">
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                className="form-control form-control-lg bg-light border-light text-center"
                                                placeholder="Enter Authentication Key"
                                                onChange={(e) => setAuthNumber(e.target.value)}
                                            />
                                        </div>
                                    </form>
                                    {error && errorMessage && (
                                        <div className="alert alert-danger mt-3" role="alert">
                                            {errorMessage}
                                        </div>
                                    )}
                                    {showMsg && msg && (
                                        <div className="alert alert-success mt-3" role="alert">
                                            {msg}
                                        </div>
                                    )}
                                    <div className="mt-3">
                                        <button
                                            type="button"
                                            className="btn btn-success w-100"
                                            onClick={insertCode}
                                        >
                                            Confirm
                                        </button>
                                    </div>
                                </div>
                            </div>

                        ) : (
                            <>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="page-title-box d-sm-flex align-items-center justify-content-between bg-galaxy-transparent">
                                            <ol className="breadcrumb m-0">
                                                <li className="breadcrumb-item"><a href="javascript: void(0);">Tables</a></li>
                                                <li className="breadcrumb-item active">Manual Operation</li>
                                            </ol>
                                            <div className="page-title-right"></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row justify-content-center mt-5">
                                    <div className="col-lg-10">
                                        <h4 className="text-center mb-4" style={{ fontSize: '22px', fontWeight: 'bold' }}>Manual Operation</h4>
                                        <div className="row g-4">
                                            {/* Manage Deposit */}
                                            <div className="col-md-6 col-lg-6">
                                                <div className="card shadow-sm border-0 rounded text-center p-4">
                                                    <div className="card-body">
                                                        <h5 className="card-title" style={{ fontSize: '18px', fontWeight: 'bold' }}>Manage Deposit</h5>
                                                        <p className="card-text">Manage deposit modifications.</p>
                                                        <div className="mt-3">
                                                            <form className="was-validated" onSubmit={handleDepositSubmit}>
                                                                <div className="mb-2 text-center">
                                                                    <label htmlFor="depositToggle" className="form-label mb-3" style={{ fontSize: '18px', fontWeight: 'bold', color: '#333' }}>
                                                                        Status
                                                                    </label>
                                                                    <div className="toggle-container" >
                                                                        <input
                                                                            type="checkbox"
                                                                            className="custom-toggle"
                                                                            id="depositToggle"
                                                                            checked={depositStatus === 'activ'}
                                                                            onChange={handleDepositStatusChange}
                                                                        />
                                                                        <label className="toggle-label" htmlFor="depositToggle">
                                                                            <span className="toggle-circle"></span>
                                                                        </label>
                                                                    </div>
                                                                    <div style={{ marginTop: '10px', fontSize: '18px', fontWeight: 'bold', color: '#555' }}>
                                                                        {depositStatus === 'activ' ? 'Activ' : 'Non Activ'}
                                                                    </div>
                                                                </div>
                                                                {depositStatus === 'nonActiv' && (
                                                                    <div className="mb-3">
                                                                        <label htmlFor="depositReason" className="form-label" style={{ fontSize: '16px', fontWeight: 'bold', color: '#555' }}>
                                                                            Reason for Non-Activation
                                                                        </label>
                                                                        <textarea
                                                                            id="depositReason"
                                                                            className="form-control"
                                                                            value={depositReason}
                                                                            onChange={handleDepositReasonChange}
                                                                            required
                                                                            rows="2"
                                                                            placeholder="Enter reason here..."
                                                                            style={{
                                                                                borderRadius: '15px',
                                                                                border: '3px solid #ddd',
                                                                                backgroundColor: '#f9f9f9',
                                                                                color: 'GrayText',
                                                                                padding: '10px',
                                                                            }}
                                                                        />

                                                                    </div>
                                                                )}
                                                                <div className="mb-2 text-center">
                                                                    <button
                                                                        className="btn btn-primary btn-lg shadow-sm"
                                                                        type="submit"
                                                                        style={{
                                                                            backgroundColor: '#4caf50',
                                                                            border: 'none',
                                                                            padding: '10px 20px',
                                                                            fontSize: '16px',
                                                                            borderRadius: '25px',
                                                                            fontWeight: 'bold',
                                                                            boxShadow: '0 4px 6px rgba(8, 8, 8, 0.69)',
                                                                        }}
                                                                    >
                                                                        Confirm Change
                                                                    </button>
                                                                </div>
                                                            </form>
                                                            {depositFormSubmitted && (
                                                                <div className="alert alert-success text-center mt-3">
                                                                    <strong>Success:</strong> Deposit Form Submitted Successfully!
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Manage Withdrawal */}
                                            <div className="col-md-6 col-lg-6">
                                                <div className="card shadow-sm border-0 rounded text-center p-4">
                                                    <div className="card-body">
                                                        <h5 className="card-title" style={{ fontSize: '18px', fontWeight: 'bold' }}>Manage Withdrawal</h5>
                                                        <p className="card-text">Manage withdrawal modifications.</p>
                                                        <div className="mt-3">
                                                            <form className="was-validated" onSubmit={handleWithdrawalSubmit}>
                                                                <div className="mb-2 text-center">
                                                                    <label htmlFor="withdrawalToggle" className="form-label mb-3" style={{ fontSize: '18px', fontWeight: 'bold', color: '#333' }}>
                                                                        Status
                                                                    </label>
                                                                    <div className="toggle-container">
                                                                        <input
                                                                            type="checkbox"
                                                                            className="custom-toggle"
                                                                            id="withdrawalToggle"
                                                                            checked={withdrawalStatus === 'activ'}
                                                                            onChange={handleWithdrawalStatusChange}
                                                                        />
                                                                        <label className="toggle-label" htmlFor="withdrawalToggle">
                                                                            <span className="toggle-circle"></span>
                                                                        </label>
                                                                    </div>
                                                                    <div style={{ marginTop: '10px', fontSize: '18px', fontWeight: 'bold', color: '#555' }}>
                                                                        {withdrawalStatus === 'activ' ? 'Activ' : 'Non Activ'}
                                                                    </div>
                                                                </div>
                                                                {withdrawalStatus === 'nonActiv' && (
                                                                    <div className="mb-3">
                                                                        <label htmlFor="withdrawalReason" className="form-label" style={{ fontSize: '16px', fontWeight: 'bold', color: '#555' }}>
                                                                            Reason for Non-Activation
                                                                        </label>
                                                                        <textarea
                                                                            id="withdrawalReason"
                                                                            className="form-control"
                                                                            value={withdrawalReason}
                                                                            onChange={handleWithdrawalReasonChange}
                                                                            required
                                                                            rows="2"
                                                                            placeholder="Enter reason here..."
                                                                            style={{
                                                                                borderRadius: '15px',
                                                                                border: '3px solid #ddd',
                                                                                backgroundColor: '#f9f9f9',
                                                                                color: 'GrayText',
                                                                                padding: '10px',
                                                                            }}
                                                                        />
                                                                    </div>
                                                                )}
                                                                <div className="mb-2 text-center">
                                                                    <button
                                                                        className="btn btn-primary btn-lg shadow-sm"
                                                                        type="submit"
                                                                        style={{
                                                                            backgroundColor: '#4caf50',
                                                                            border: 'none',
                                                                            padding: '10px 20px',
                                                                            fontSize: '16px',
                                                                            borderRadius: '25px',
                                                                            fontWeight: 'bold',
                                                                            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                                                                        }}
                                                                    >
                                                                        Confirm Change
                                                                    </button>
                                                                </div>
                                                            </form>
                                                            {withdrawalFormSubmitted && (
                                                                <div className="alert alert-success text-center mt-3">
                                                                    <strong>Success:</strong> Withdrawal Form Submitted Successfully!
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>

            <Footer />
            <ToastContainer />
        </>
    );
}
